import React from 'react';
import { useTranslation } from 'react-i18next';
import { CardWithHeader } from '../../../../ui/CardWithHeader';
import { DonutChart } from '../DonutChart';
import { HydratedDonutBlock } from '../../../../../services/admin/cloudAgentTypes';
import { BlockSourceNote } from './BlockSourceNote';

/** donut → DonutChart (dumb) inside a titled card. */
export const DonutBlock: React.FC<{ block: HydratedDonutBlock }> = ({ block }) => {
  const { t } = useTranslation();
  return (
    // Own horizontal scroller: the legend must never widen the page on mobile.
    <div className="overflow-x-auto">
      <CardWithHeader title={block.title ?? t('cloudAgent.blockTitles.donut')}>
        <DonutChart slices={block.data.slices} emptyText={t('common.noDataInPeriod')} />
      </CardWithHeader>
      <BlockSourceNote source={block.source} />
    </div>
  );
};
